<template>
  <div class="page-productShare">
    <Navigation title="创建分享" v-if="!isDshApp"/>
    <div class="share-content">
      <div class="earnings-wrap">
        <img class="earnings-icon" :src="shareMoneyIcon" />
        <span class="earnings-money">推广收益预估 ¥{{ goodsData.sharePrice }}</span>
      </div>
      <div class="introduce-wrap">
        <div class="goods-title">{{ goodsData.title }}</div>
        <div class="goods-share-info">
          <span v-html="shareContent.replace(/\n/g, '\<br/>')"></span>
        </div>
      </div>
      <div class="check-wrap showOpt">
        <div class="check-item">
          <img class="icon-check" @click="handleClickShowItem(1)" :src="showShareMoney ? checkedIcon : unCheckedIcon" /><span>收益</span>
        </div>
        <div class="check-item" v-show="tkl.length > 0">
          <img class="icon-check" @click="handleClickShowItem(2)" :src="showTkl ? checkedIcon : unCheckedIcon" /><span>淘口令</span>
        </div>
        <div class="check-item" v-if="isDSH">
          <img class="icon-check" @click="handleClickShowItem(4)" :src="showProductUrl ? checkedIcon : unCheckedIcon" /><span>商品链接</span>
        </div>
        <div class="check-item">
          <img class="icon-check" @click="handleClickShowItem(3)" :src="showBuyUrl ? checkedIcon : unCheckedIcon" /><span>购买链接</span>
        </div>
      </div>
      <div class="check-wrap">
        <div class="check-item copy copyTkl" :data-clipboard-text="getCopyTkl()" v-show="tkl.length > 0">
          <img class="icon-copy" :src="copyIcon" /><span>淘口令</span>
        </div>
        <div class="check-item copy copyProductUrl" v-show="isDSH" :data-clipboard-text="shortProductUrl">
          <img class="icon-copy" :src="copyIcon" /><span>商品链接</span>
        </div>
        <div class="check-item copy copyBuyUrl" :data-clipboard-text="shortBuyUrl">
          <img class="icon-copy" :src="copyIcon" /><span>购买链接</span>
        </div>
        <div class="check-item"></div>
      </div>
      <div class="shareImg-wrap">
        <div class="share-poster">
          <md-activity-indicator
          class="icon-indicator"
            v-show="!sharePosterImg && loadSharePosterStatus === 0"
            type="spinner"
            :size="30"
            :text-size="20"
          ></md-activity-indicator>
          <div class="btn-retry-loadPoster" v-show="loadSharePosterStatus === 2" @click="fetchSharePoster()"><p>海报加载失败</p><p>请点击重试</p></div>
          <img class="img-poster" v-show="sharePosterImg && loadSharePosterStatus === 1" :src="sharePosterImg" @click="handleClickPreviewPosterImg()"/>
        </div>
        <div class="share-imgs" v-if="goodsData.smallPicUrl.length > 0">
          <div class="imgs-col"><img class="img-item" v-for="(item, index) in goodsData.smallPicUrl" :src="formatHttpImg(item)" v-if="index < 3" @click="handleClickPreviewBannerImg(index)"/></div>
          <div class="imgs-col"><img class="img-item" v-for="(item, index) in goodsData.smallPicUrl" :src="formatHttpImg(item)" v-if="index >= 3 && index < 6" @click="handleClickPreviewBannerImg(index)"/></div>
        </div>
      </div>
    </div>
    <div class="option-wrap">
      <div class="btn-share copy copyShareContent" :data-clipboard-text="getShareContent()">复制文案</div>
      <div class="btn-share pic" @click="handleClickSaveImg()">分享图片</div>
    </div>
    <md-image-viewer v-model="showPreviewImg" :list="previewImgList" :has-dots="true" :initial-index="previewImgIndex"></md-image-viewer>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import { isTbkey, formatSaleCount, isDshApp } from '@/utils/help'
import LocalStore from '@/utils/localStore'
import Consts from '@/common/consts'
import Clipboard from 'clipboard'
import { ActivityIndicator, ImageViewer, Toast } from 'mand-mobile'
import { mapGetters } from 'vuex'
import qs from 'qs'
import _AP from '@/utils/ap'

/**
const productItem = {
  buyPrice: 15.9,
  picUrl: 'https://img.alicdn.com/tfscom/i1/3878483432/O1CN010k8ogo1bDtqcgBvj2_!!0-item_pic.jpg',
  marketPrice: 69,
  couponAmount: 1,
  sharePrice: 0.25,
  salesVolume: 2074,
  goodsId: 595997323214,
  goldenBeans: 12,
  couponClickUrl:
    'https://uland.taobao.com/coupon/edetail?e=TQCZ%2F1LizvgGQASttHIRqR8uJzmpFax8YqXW9vejEUYzTAsPwf4oeG4TeH65VXVLYyeCZ6oHhM8dlEDK%2F3jf%2B5%2BNsQz1ZeJFRv%2B8NlZ1Yr1Sje14g2G3LCVwYEZYh9cwBY2mYYKU440Zao0HO%2FvX0w%3D%3D&union_lens=lensId:0b1af702_527e_16e7c6fdb99_beb9',
  buyUrl:
    'https://s.click.taobao.com/t?e=m%3D2%26s%3DYIZj5aWyc%2BQcQipKwQzePOeEDrYVVa64yK8Cckff7TXjf2vlNIV67kpmBELP4V2%2BAMg8lLLxypo2OVLkyDHzy8w07B0o2CWYX9Tv%2FeLmLA9OeIUbE8ba4v0jCkSDmD6DKe3%2FbelnU7chre9gvq5P3zKYVV1BId1rfp5HoTJX0vVZW9O6z%2FdQD0LgtoCmJMxz3930lyqI4HbYgduoWnJ1SJx1Q4Hkt9oSipYw3UORxig5hDCuE8TSLA%3D%3D&union_lens=lensId:0b1af702_527e_16e7c6fdb99_beb9',
  source: '天猫',
  title: '长袖t恤女打底衫春秋装韩版学生宽松ins潮闺蜜装慵懒风中长款上衣',
}
 */
export default {
  name: 'productShare',
  components: {
    Navigation,
    [ActivityIndicator.name]: ActivityIndicator,
    [ImageViewer.name]: ImageViewer,
  },
  data() {
    return {
      isDshApp: isDshApp(),
      goodsId: '',
      channel: '',
      showPreviewImg: false,
      previewImgList: [],
      previewImgIndex: 0, // 预览图片的索引
      checkedIcon: require('../assets/images/icon_checked.png'),
      unCheckedIcon: require('../assets/images/icon_unchecked.png'),
      shareMoneyIcon: require('../assets/images/ic_share_money.png'),
      copyIcon: require('../assets/images/icon_copy.png'),
      showShareMoney: true, // 显示推广收益
      showTkl: true, // 显示淘口令
      showProductUrl: false, // 显示商品链接
      showBuyUrl: true, // 显示购买链接
      productUrl: '', // 商品链接
      shortProductUrl: '', // 商品链接
      buyUrl: '', // 购买链接
      shortBuyUrl: '', // 短网址购买链接
      goodsData: null,
      tkl: '', // 淘口令
      shareContent: '', // 分享内容
      // sharePosterImg: 'http://dshui-wap.oss-cn-hangzhou.aliyuncs.com/userPoster/1575101160741ZZDWeW.jpeg',
      loadSharePosterStatus: 0, // 0:加载中, 1:加载成功 2:加载失败
      sharePosterImg: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isDSH() {
      // 是管理员
      const arr = ['18973542391', '19957635657', '18615348226', '18774679100', '18001130332', '13241882222', '13708614755', '17686376158', '13121569893', '13633711930', '15937997925', '13938281250', '17839948450', '17839943596', '18339961026', '15239969679', '17195875211', '18538941084', '15537923520', '15713806917', '18221213546']
      if (arr.indexOf(this.userInfo.mobile) > -1) {
        this.showProductUrl = true
        return true
      }
      this.showProductUrl = false
      return false
    }
  },
  mounted() {
    const clipboard1 = new Clipboard('.copyTkl')
    clipboard1.on('success', e => {
      Toast.succeed('淘口令复制成功', 1500)
      e.clearSelection()
    })
    const clipboard2 = new Clipboard('.copyBuyUrl')
    clipboard2.on('success', e => {
      Toast.succeed('购买链接复制成功', 1500)
      e.clearSelection()
    })
    const clipboard3 = new Clipboard('.copyProductUrl')
    clipboard3.on('success', e => {
      Toast.succeed('商品链接复制成功', 1500)
      e.clearSelection()
    })
    const clipboard4 = new Clipboard('.copyShareContent')
    clipboard4.on('success', e => {
      Toast.succeed('文案复制成功', 1500)
      e.clearSelection()
    })
  },
  created() {
    this.goodsId = this.$route.query.goodsId
    this.channel = this.$route.query.channel || 'tbk'
    this.productUrl = decodeURIComponent(this.$route.query.productUrl || '') // 商品链接
    this.goodsData = LocalStore.get(Consts.STORE_SHARE_PRODUCT)
    if (this.channel === 'tbk') {
      this.getTkl()
    } else {
      this.fetchGoodsDetailBuyUrl('share', (url) => {
        this.buyUrl = url // 购买链接
        if (this.isDSH) {
          this.fetchShortProductUrl()
        } else {
          this.fetchShortBuyUrl()
        }
      })
    }
  },
  methods: {
    /**
     * 获取淘口令
     */
    getTkl() {
      this.$http.tbk.getTkl(this.goodsData.title, this.goodsData.couponClickUrl, this.goodsData.buyUrl).then(res => {
        this.tkl = res.data
        const params = {
          inviterAvatar: this.userInfo.photo,
          inviterName: this.userInfo.cnName,
          buyPrice: this.goodsData.buyPrice,
          pic: this.goodsData.picUrl,
          marketPrice: this.goodsData.marketPrice,
          coupon: this.goodsData.couponAmount,
          title: this.goodsData.title,
          tkl: this.tkl,
          saleCount: formatSaleCount(this.goodsData.salesVolume),
        }
        this.buyUrl = `${location.origin}/product/tkl?${qs.stringify(params)}` // 购买链接
        if (this.isDSH) {
          this.fetchShortProductUrl()
        } else {
          this.fetchShortBuyUrl()
        }
      })
    },
    /**
     * 查询 拼多多/京东/唯品会 商品购买url
     */
    fetchGoodsDetailBuyUrl(type, callbackFunc) {
      let promise
      if (this.channel === 'pdd' || this.channel === 'vph') {
        promise = this.$http[this.channel].goodsDetailBuyUrl(this.goodsId, type)
      } else if (this.channel === 'jd') {
        const materialUrl = decodeURIComponent(this.$route.query.materialUrl || '')
        const couponUrl = decodeURIComponent(this.$route.query.couponUrl || '')
        promise = this.$http[this.channel].goodsDetailBuyUrl(materialUrl, couponUrl, type)
      }
      if (promise) {
        promise.then(res => {
          callbackFunc(res.data)
        })
      }
    },
    /**
     ** 获取商品短链接
    */
    fetchShortProductUrl() {
      this.$http.common.getShortUrl(this.productUrl).then(res => {
        this.shortProductUrl = res.data.shorturl
        this.fetchShortBuyUrl()
      }).catch(() => {
        this.shortProductUrl = this.productUrl
        this.fetchShortBuyUrl()
      })
    },
    /**
     ** 获取购买短链接
    */
    fetchShortBuyUrl() {
      this.$http.common.getShortUrl(this.buyUrl).then(res => {
        this.shortBuyUrl = res.data.shorturl
        this.fetchSharePoster()
        this.setShareContent()
      }).catch(() => {
        this.shortBuyUrl = this.buyUrl
        this.fetchSharePoster()
        this.setShareContent()
      })
    },
    /**
     * 获取分享海报
     */
    fetchSharePoster() {
      this.loadSharePosterStatus = 0
      this.$http.common.getSharePoster(this.shortBuyUrl, this.userInfo.photo, this.userInfo.cnName, this.goodsData.source, this.goodsData.couponAmount > 0 ? `${this.goodsData.couponAmount}元券` : '', this.goodsData.picUrl, this.goodsData.title, this.formatStrAmount(this.goodsData.marketPrice + ''), this.formatStrAmount(this.goodsData.buyPrice + '')).then(res => {
        console.log('获取分享海报', res)
        this.sharePosterImg = res.data
        this.loadSharePosterStatus = 1
      }).catch(() => {
        this.loadSharePosterStatus = 2
      })
    },
    /**
     * 设置分享内容
     */
    setShareContent() {
      let str = `【原价】${this.formatStrAmount(this.goodsData.marketPrice)}元\n【券后价】${this.formatStrAmount(this.goodsData.buyPrice)}元 \n`
      if (this.showShareMoney) {
        str += `【推广收益预估】${this.formatStrAmount(this.goodsData.sharePrice)}元 \n`
      }
      if (this.showTkl && this.tkl) {
        str += `---------------------------------- \n復製这条${this.tkl}进入【Tao宝】即可抢购\n`
      }
      if (this.showBuyUrl && this.shortBuyUrl) {
        str += `---------------------------------- \n【购买链接】\n${this.shortBuyUrl}\n`
      }
      if (this.showProductUrl && this.shortProductUrl) {
        str += `---------------------------------- \n【商品链接】\n${this.shortProductUrl}\n`
      }
      this.shareContent = str
    },

    /**
     * 获取复制的淘口令
     */
    getCopyTkl() {
      return `復製这条${this.tkl}进入【Tao宝】即可抢购`
    },
    /**
     *  获取复制的分享内容
     */
    getShareContent() {
      return `${this.goodsData.title}\n\n${this.shareContent}`
    },
    /**
     * 点击显示
     */
    handleClickShowItem(index) {
      if (index === 1) {
        this.showShareMoney = !this.showShareMoney
      } else if (index === 2) {
        this.showTkl = !this.showTkl
      } else if (index === 3) {
        this.showBuyUrl = !this.showBuyUrl
      } else if (index === 4) {
        this.showProductUrl = !this.showProductUrl
      }
      this.setShareContent()
    },
    /**
     * 点击预览商品海报
     */
    handleClickPreviewPosterImg() {
      this.previewImgList = []
      this.previewImgList[0] =  this.sharePosterImg
      for (let i = 0; i < this.goodsData.smallPicUrl.length; i++) {
        this.previewImgList[i + 1] = this.goodsData.smallPicUrl[i]
      }
      this.previewImgIndex = 0
      this.showPreviewImg = true
    },
    /**
     * 点击预览轮播图
     */
    handleClickPreviewBannerImg(index) {
     this.previewImgList = []
      this.previewImgList[0] =  this.sharePosterImg
      for (let i = 0; i < this.goodsData.smallPicUrl.length; i++) {
        this.previewImgList[i + 1] = this.goodsData.smallPicUrl[i]
      }
      this.previewImgIndex = index + 1
      this.showPreviewImg = true
    },
    /**
     * 点击保存图片
     */
    handleClickSaveImg() {
      Toast.succeed('长按图片可保存或转发', 1500)
    }
  },
}
</script>

<style lang="scss" scoped>
.page-productShare {
  position: relative;
  overflow: hidden;
  min-height: 100%;
  background: #f8f8f8;
  padding-bottom: 1.4rem;
  .share-content {
    background: #f8f8f8;
    padding: 0.32rem 0.2rem;
    .earnings-wrap {
      // 奖励收益预估
      padding: 0 0.2rem;
      height: 0.6rem;
      border-radius: 0.3rem;
      background: #fff;
      display: flex;
      align-items: center;
      .earnings-icon {
        display: inline-block;
        height: 0.36rem;
      }
      .earnings-money {
        margin-left: 0.12rem;
        display: inline-block;
        font-size: 0.25rem;
        color: #885f1d;
      }
    }
    .introduce-wrap {
      // 产品介绍
      background: #fff;
      border-radius: 0.08rem;
      margin-top: 0.16rem;
      padding: 0.3rem;
      .goods-title {
        margin: 0 0.3rem;
        color: #333;
        font-size: 0.3rem;
      }
      .goods-share-info {
        color: #999;
        margin: 0.2rem 0.3rem;
        font-size: 0.26rem;
        word-wrap: break-word;
      }
    }
  }
  .check-wrap {
    // 选择项
    display: flex;
    align-items: center;
    background: #fff;
    padding: 0.2rem 0.2rem;
    &.showOpt {
      margin-top: 0.2rem;
      padding-bottom: 0.1rem;
    }
    .check-item {
      flex: 1;
      margin: 0 0.1rem;
      float: left;
      display: flex;
      align-items: center;
      color: #ef3233;
      font-size: 0.24rem;
      white-space: nowrap;
      justify-content: center;
      &:active {
        opacity: 0.3;
      }
      .icon-check {
        height: 0.36rem;
        margin-right: 0.2rem;
      }
      .icon-copy {
        height: 0.24rem;
        margin-right: 0.1rem;
      }
      &.copy {
        background: #ffe4e4;
        border-radius: 1rem;
        padding: 0.04rem 0.12rem;
      }
    }
  }
  .shareImg-wrap {
    height: 5.4rem;
    .share-poster {
      position: relative;
      float: left;
      width: 50%;
      margin: 0.1rem 0 0.2rem;
      background: #fff;
      height: 100%;
      .icon-indicator {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .btn-retry-loadPoster {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 80%;
        text-align: center;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.1);
        color: #ef3d3d;
        font-size: 0.24rem;
        padding: 0.3rem;
        border-radius: 0.04rem;
        &:active {
          opacity: 0.3;
        }
      }
      .img-poster {
        width: 100%;
      }
    }
    .share-imgs {
      float: left;
      width: 50%;
      display: flex;
      flex-direction: row;
      .imgs-col {
        display: flex;
        flex-direction: column;
      }
      .img-item {
        width: 1.6rem;
        height: 1.6rem;
        margin: 0.1rem;
      }
    }
    .icon-check {
      position: absolute;
      top: 0.2rem;
      right: 0.1rem;
      height: 0.36rem;
    }
  }
  .option-wrap {
    // 分享按钮操作
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0.9rem;
    padding: 0.1rem 0.2rem;
    display: flex;
    justify-content: space-between;
    .btn-share {
      flex: 1;
      text-align: center;
      border-radius: 1rem;
      line-height: 0.7rem;
      font-size: 0.3rem;
      color: #fff;
      &:active {
        opacity: 0.4;
      }
      &.copy {
        background: #ff971b;
        margin-right: 0.1rem;
      }
      &.pic {
        background: #ef3d3d;
        margin-left: 0.1rem;
      }
    }
  }
}
</style>
